import authHeader from 'srcReact/helpers/auth-header'
import axios from 'axios'
import { doRequestAxios } from 'srcReact/helpers/apiHelper'

export const eventService = {
  sendInvites,
  createEvent,
  editEvent,
  getEventDetailById,
  getFeeCategories,
  getRecurrenceEndDate,
  getParticipants,
  deleteFileFromMixr,
  addStaffRole,
  removeStaffRole,
  cancelMixr,
  getMedia,
  saveDraft,
  getDrafts,
  getDraftDetail,
  deleteDraft,
  getExistingMixrList,
  getUsersToInvite,
  updateAttendingMixr,
  rejectInvitation,
  updateMixrRating,
  getMoreReviews
}

let cancel

function sendInvites(mixrId, usersId, message) {
  const params = {
    mixr_id: mixrId,
    message,
    users_id: usersId
  }

  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: params
  }
  return doRequestAxios(`/v2/mixr/invitation/send`, requestOptions)
}

function getEventDetailById(eventId, scope) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  const param = scope && scope.length > 0 ? `&scope=${scope}` : ''
  return doRequestAxios(`/v2/mixr/information?mixr_id=${eventId}${param}`, requestOptions)
}

function getParticipants(eventId, scope, attendingType, offset, quantity, search, order) {
  if (cancel) {
    cancel()
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cancelToken: new axios.CancelToken((c) => (cancel = c))
  }
  let params = scope && scope.length > 0 ? `&scope=${scope}` : ''
  if (scope === 'all') {
    params += search.length > 0 ? `&all_search=${search}` : ''
    params += `&all_order=${order}`
    params += offset ? `&all_offset=${offset}` : ''
    params += quantity ? `&all_quantity=${quantity}` : ''
  } else if (scope === 'participants') {
    params += search.length > 0 ? `&participants_search=${search}` : ''
    params += `&participants_order=${order}`
    params += offset ? `&participants_offset=${offset}` : ''
    params += quantity ? `&participants_quantity=${quantity}` : ''
    params += attendingType ? `&participants_attending_type=${attendingType}` : ''
  } else if (scope === 'staff') {
    params += search.length > 0 ? `&staff_search=${search}` : ''
    // params += `&participants_order=${order}`
    params += offset ? `&staff_offset=${offset}` : ''
    params += quantity ? `&staff_quantity=${quantity}` : ''
  } else if (scope === 'not_going') {
    params += search.length > 0 ? `&not_going_search=${search}` : ''
    params += `&not_going_order=${order}`
    params += offset ? `&not_going_offset=${offset}` : ''
    params += quantity ? `&not_going_quantity=${quantity}` : ''
  } else if (scope === 'invited_all') {
    params += search.length > 0 ? `&invited_all_search=${search}` : ''
    params += offset ? `&invited_all_offset=${offset}` : ''
    params += quantity ? `&invited_all_quantity=${quantity}` : ''
  } else if (scope === 'invited_no_reply') {
    params += search.length > 0 ? `&invited_no_reply_search=${search}` : ''
    params += offset ? `&invited_no_reply_offset=${offset}` : ''
    params += quantity ? `&invited_no_reply_quantity=${quantity}` : ''
  } else if (scope === 'invited_not_going') {
    params += search.length > 0 ? `&invited_not_going_search=${search}` : ''
    params += offset ? `&invited_not_going_offset=${offset}` : ''
    params += quantity ? `&invited_not_going_quantity=${quantity}` : ''
  } else if (scope === 'invited_going') {
    params += search.length > 0 ? `&invited_going_search=${search}` : ''
    params += offset ? `&invited_going_offset=${offset}` : ''
    params += quantity ? `&invited_going_quantity=${quantity}` : ''
  }
  return doRequestAxios(`/v2/mixr/information?mixr_id=${eventId}${params}`, requestOptions)
}
function createEvent(groupId, event) {
  if (!event?.id_external_api_auth) {
    delete event.id_external_api_auth
  }
  const requestOptions = {
    method: 'POST',
    headers: authHeader(),
    data: event
  }
  return doRequestAxios(`/v2/mixr/creation/add?group_id=${groupId}`, requestOptions)
}

function editEvent(eventId, event, recurrenceUpdate = 'unique') {
  if (event.location) {
    event.location = JSON.stringify(event.location)
  }
  if (!event?.id_external_api_auth) {
    delete event.id_external_api_auth
  }
  if (event.fees && event.fees.length > 0) {
    let updatedFees = []
    updatedFees = event.fees.map((f) => {
      return {
        amount: f.amount,
        currency_code: f.currency_code,
        category_id: f.category_id,
        category_other: f.category_other || '',
        link: f.link
      }
    })
    event.fees = JSON.stringify(updatedFees)
  }
  event.recurrence_update = recurrenceUpdate
  event.attendance_limits =
    event.attendance_limits && event.attendance_limits.length > 0 ? JSON.stringify(event.attendance_limits) : ''
  if (event.attending_type === 'in_person') {
    delete event.join_in_link
  }
  delete event.color
  if (event.additional_information === null) {
    event.additional_information = ''
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: event
  }
  return doRequestAxios(`/v2/mixr/edition/update?mixr_id=${eventId}`, requestOptions)
}

function getFeeCategories(language) {
  let param = ''
  if (language) {
    param = `?language=${language}`
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/mixr/fees-categories/list${param}`, requestOptions)
}

function getRecurrenceEndDate(
  startAt,
  endAt,
  recurrenceType,
  recurrenceEndDate = null,
  recurrenceWeeksCount = -1,
  recurrenceDaysOfWeek = '',
  recurrenceMonthsCount = -1,
  recurrenceDayOfWeek = -1,
  recurrenceOccurenceInMonth = -1
) {
  let params = ''
  if (recurrenceEndDate) {
    params += `&recurrence_end_date=${recurrenceEndDate}`
  }
  if (recurrenceWeeksCount && recurrenceWeeksCount > 0) {
    params += `&recurrence_weeks_count=${recurrenceWeeksCount}`
  }
  if (recurrenceDaysOfWeek && recurrenceDaysOfWeek.length > 0) {
    params += `&recurrence_days_of_week=${recurrenceDaysOfWeek}`
  }
  if (recurrenceMonthsCount && recurrenceMonthsCount > 0) {
    params += `&recurrence_months_count=${recurrenceMonthsCount}`
  }
  if (recurrenceType === 'monthly' && recurrenceDayOfWeek >= 0) {
    params += `&recurrence_day_of_week=${recurrenceDayOfWeek}`
  }
  if (recurrenceOccurenceInMonth && recurrenceOccurenceInMonth > 0) {
    params += `&recurrence_occurence_in_month=${recurrenceOccurenceInMonth}`
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(
    encodeURI(
      `/v2/mixr/creation/recurrence/get-max-end-date?start_at=${startAt}&end_at=${endAt}&recurrence_type=${recurrenceType}${params}`
    ),
    requestOptions
  )
}

function deleteFileFromMixr(mixrId, fileId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: null
  }
  return doRequestAxios(`/v2/mixr/file/remove?mixr_id=${mixrId}&file_id=${fileId}`, requestOptions)
}

function addStaffRole(mixrId, userId, role) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: null
  }
  return doRequestAxios(`/v2/mixr/staff/role/add?mixr_id=${mixrId}&user_id=${userId}&role=${role}`, requestOptions)
}

function removeStaffRole(mixrId, userId) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: null
  }
  return doRequestAxios(`/v2/mixr/staff/role/remove?mixr_id=${mixrId}&user_id=${userId}`, requestOptions)
}

function cancelMixr(mixrId, recurrenceCancel = 'unique') {
  const payload = {
    recurrence_cancel: recurrenceCancel
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios(`/v2/mixr/edition/cancel?mixr_id=${mixrId}`, requestOptions)
}

function getMedia(id, scope, offset, quantity) {
  let params = { scope: scope }
  if (scope === 'pictures_media') {
    params.pictures_media_offset = offset
    params.pictures_media_quantity = quantity
  } else if (scope === 'documents_media') {
    params.documents_media_offset = offset
    params.documents_media_quantity = quantity
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: params
  }
  return doRequestAxios(`/v2/mixr/information?mixr_id=${id}`, requestOptions)
}

function getMoreReviews(mixrId, offset, quantity) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: { scope: 'rating', rating_offset: offset, rating_quantity: quantity }
  }
  return doRequestAxios(`/v2/mixr/information?mixr_id=${mixrId}`, requestOptions)
}

function saveDraft(event) {
  if (event.id_external_api_auth === 0) {
    delete event.id_external_api_auth
  }
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: event
  }
  return doRequestAxios(`/v2/mixr/creation/save-draft-mixr`, requestOptions)
}

function getDrafts(organizationId, groupId, searchGroupId, search, offset, quantity) {
  if (cancel) {
    cancel()
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    cancelToken: new axios.CancelToken((c) => (cancel = c)),
    params: {
      organization_id: organizationId,
      search,
      offset,
      quantity,
      group_id: groupId,
      search_group_id: searchGroupId
    }
  }
  return doRequestAxios(`/v2/mixr/creation/get-draft-mixrs`, requestOptions)
}

function getDraftDetail(draftId) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/mixr/creation/get-draft-mixr?draft_id=${draftId}`, requestOptions)
}

function deleteDraft(draftId) {
  const requestOptions = {
    method: 'DELETE',
    headers: authHeader()
  }
  return doRequestAxios(`/v2/mixr/creation/delete-draft-mixr?draft_id=${draftId}`, requestOptions)
}

function getExistingMixrList(organizationId, groupId, searchGroupId, search, offset, quantity) {
  const payload = {
    organization_id: organizationId,
    search,
    offset,
    quantity,
    group_id: groupId,
    search_group_id: searchGroupId
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: payload
  }
  return doRequestAxios(`/v2/mixr/creation/get-mixr-list`, requestOptions)
}

function getUsersToInvite(mixr_id, scope, offset, quantity, search = '', order = '') {
  if (cancel) {
    cancel()
  }
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    params: {
      mixr_id,
      scope,
      suggested_members_offset: offset,
      suggested_members_quantity: quantity,
      suggested_members_search: search,
      suggested_members_order: order
    },
    cancelToken: new axios.CancelToken((c) => (cancel = c))
  }
  return doRequestAxios(`/v2/mixr/information`, requestOptions)
}

function updateAttendingMixr(mixr_id, attending, recurrence_option) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { mixr_id, attending, recurrence_option }
  }
  return doRequestAxios(`/v2/mixr/attending/update`, requestOptions)
}

function rejectInvitation(mixr_id) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    params: { mixr_id }
  }
  return doRequestAxios(`/v2/mixr/invitation/refuse`, requestOptions)
}

function updateMixrRating(organizationId, mixrId, isPublic, rating, review) {
  const requestOptions = {
    method: 'PUT',
    headers: authHeader(),
    data: { organization_id: organizationId, mixr_id: mixrId, is_public: isPublic, rating, review }
  }
  return doRequestAxios(`/v2/mixr/rating/save`, requestOptions)
}
